import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth/auth.guard';
import { AuthLoginService } from '../services/auth-login/auth-login.service';
import { LoginComponent } from './login/login.component';

const loginRoutes: Routes = [
  { path: 'login', title: 'auth.label', component: LoginComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(loginRoutes)],
  exports: [RouterModule],
  providers: [AuthLoginService]
})
export class AuthRoutingModule {}
